export class ReasonCodesModel {
  id: number;
  reasonCode: string;
  reasonType: string;
  description: string;
  isEditable = false;
}
